import { gql } from '@apollo/client';
import { UserFragment } from '../fragments';
import { SlackDestinationFieldsFragment } from '../slack/fragments';

export const PermissionFragment = gql`
  fragment PermissionFields on Permission {
    key
    name
    action
    assignableSchemas {
      id
      name
    }
  }
`;
export const PermissionAssignmentFragment = gql`
  fragment PermissionAssignmentFields on PermissionAssignment {
    permission {
      ...PermissionFields
    }
    schemas {
      id
      name
    }
  }
  ${PermissionFragment}
`;

export const RoleMetaFieldsFragment = gql`
  fragment RoleMetaFields on Role {
    id
    name
    description
    type
    active
  }
`;

export const RoleWithPermissionsFieldsFragment = gql`
  fragment RoleWithPermissionsFields on Role {
    ...RoleMetaFields
    permissionAssignments {
      ...PermissionAssignmentFields
    }
  }
  ${RoleMetaFieldsFragment}
  ${PermissionAssignmentFragment}
`;

export const UserGroupMetaFragment = gql`
  fragment UserGroupMetaFields on UserGroup {
    active
    type
    id
    name
    description
  }
`;

export const UserGroupFragment = gql`
  fragment UserGroupFields on UserGroup {
    ...UserGroupMetaFields
    users {
      ...UserFields
    }
    roles {
      id
      name
    }
  }
  ${UserFragment}
  ${UserGroupMetaFragment}
`;

/**
 * Consider to use this fragment for single user data only because
 * groups and roles fields are expensive
 */
export const UserPermissionFragment = gql`
  fragment UserPermissionFields on User {
    ...UserFields
    groups {
      ...UserGroupMetaFields
      roles {
        ...RoleWithPermissionsFields
      }
    }
    roles {
      ...RoleWithPermissionsFields
    }
  }
  ${UserFragment}
  ${UserGroupMetaFragment}
  ${RoleWithPermissionsFieldsFragment}
`;

export const FormatSettingFragment = gql`
  fragment FormatSettingFields on FormatSetting {
    date
    time
    locale
    currency
  }
`;

export const FormatSettingConfigFragment = gql`
  fragment FormatSettingConfigFields on FormatSettingConfig {
    dateFormats
    timeFormats
    locales
    currencies
  }
`;

/**
 * This fragment was added specifically for UsersTable that can render a large
 * list of users.
 * All fields are specifically added for table columns only.
 */
export const UserTableFieldsFragment = gql`
  fragment UserTableFields on User {
    ...UserFields
    inviteExpireAt
    invitedAt
    roles {
      ...RoleMetaFields
    }
  }
  ${UserFragment}
  ${RoleMetaFieldsFragment}
`;

export const AdminNotificationsFragment = gql`
  fragment AdminNotificationSettingsFields on AdminNotificationSettings {
    emails
    slackDestination {
      ...SlackDestinationFields
    }
    notifications {
      destinationTypes
      event {
        key
        name
      }
    }
  }
  ${SlackDestinationFieldsFragment}
`;
